{
  "delete": "Delete",
  "comment": "comment",
  "production_company": "Production company",
  "city": "City",
  "languages": "Languages",
  "TV_campaigns": "TV campaigns",
  "awards": "Awards",
  "files_and_links": "Files and links",
  "social_accounts": "Social Accounts",
  "error_talent": "An error has occurred while displaying this talent"
}
